import * as React from 'react'
import SelectSearch from 'react-select-search';

class ItemMoney extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isCheck: '',
            isChoose: '',
            selectValue: '',
            priceDonate: 0,
        }
        this.handleCheckBox = this.handleCheckBox.bind(this)
        this.getSelectValue = this.getSelectValue.bind(this)
        this.getPriceDonate.bind(this);
        
    }

   

    getPriceDonate = (event, callback) => {
        let price = event.target.innerText.replace("S$", "");
        if( typeof callback == "function"){
            this.setState((state) => (
                {priceDonate: parseFloat(price)}
            ),callback);
        }
        let currentEle = event.target;
        let parrent =  currentEle.parentElement;
        let nextParrentEle = parrent.nextSibling;
        let removeLastState = parrent.querySelector('.active');
        nextParrentEle && nextParrentEle.classList.remove('active')
        removeLastState && removeLastState.classList.remove('active');
        currentEle.classList.add('active');  
        
    }

    getPriceOtherDonate = (event) =>{
        let currentEle = event.target;
        if(currentEle.tagName != 'INPUT'){
            let parrent =  currentEle.parentElement;
            let nextParrentEle = parrent.nextSibling;
            let removeLastState = parrent.querySelector('.active');
            nextParrentEle && nextParrentEle.classList.add('active')
            removeLastState && removeLastState.classList.remove('active');
            currentEle.classList.add('active');  
        }else{
            let price = event.target.value;
            this.setState((state) => ({priceDonate: parseFloat(price)}))
        }        
    }

    getSelectValue = (value) => {
        this.setState((state) => ({
            selectValue: value
        }))
    }

    handleCheckBox = (event) => {
        let value = event.target;
        if (value.checked) {
            this.setState((state) => ({
                isCheck: 'active'
            }))
        } else {
            this.setState((state) => ({
                isCheck: ''
            }))
        }
    }

    render() {
        let data = this.props.data;
        let index = this.props.index;
        let count = this.props.count;
        const updatePrice = () => {
            this.props.getValue(this.state.priceDonate,index);
        }
        const ItemsMoney = data.map((item) => {
            let { price_donate, _id } = item
            return (
                <div key={`price-item${_id}`} onClick={() =>{this.getPriceDonate(event,updatePrice)}} className="ecf-form-donate__item-price-item">
                    S${price_donate}
                </div>
            )
        })
        return (
            <div className={`ecf-form-donate__item-price-list ${this.props.active}`}>
                <h4 className="ecf-form-donate__item-price-list-label">
                    How much would you like to give?
                    {
                        (index != 0) && (
                            <button className="ecf-btn-form-remove" aria-label="ecf-btn-form-remove">
                                <i className="far fa-times"></i><span>Remove</span>
                            </button>
                        )
                    }
                </h4>
                <div className="ecf-form-donate__item-price-list-contain">
                    {ItemsMoney}
                    <div onClick={() =>{this.getPriceOtherDonate(event)}} className="ecf-form-donate__item-price-item">
                        Other
                    </div>
                </div>
                <div className="ecf-form-donate__item-price-list-other">
                    <label htmlFor="donatedSpecific">
                        <span className="label">
                            Enter amount
                        </span>
                        <span className="currency">
                            S$
                        </span>
                        <input
                            name="otherPrice"
                            type="number"
                            id="otherPrice"
                            onChange={() =>{this.getPriceOtherDonate(event); updatePrice()}}
                        />
                    </label>
                </div>
                <div className="ecf-form-donate__item-price-list-check-box">
                    <input
                        name={`donatedSpecific-${index}`}
                        type="checkbox"
                        id={`donatedSpecific-${index}`}
                        value={true}
                        // checked={this.state.isGoing}
                        onChange={this.handleCheckBox}
                    />
                    <label htmlFor={`donatedSpecific-${index}`}>
                        <span>
                            Donate to a specific programme
                        </span>
                    </label>
                </div>
                <div className={`ecf-form-donate__item-price-list-add-more ${this.state.isCheck}`}>
                    <div className="ecf-form-donate__item-price-list-add-more-programme">
                        <SelectSearch
                            options={this.props.options}
                            class="select--custom"
                            search
                            onBlur={this.handleSelection}
                            onChange={this.getSelectValue}
                            name={`SelectCustom-${index}`}
                            placeholder="Choose a programme" />
                    </div>
                    {
                        (this.state.selectValue) && (
                            <div className="more--button">
                                <button className="btn-acf-form-add" onClick={this.props.handleAddPrefer} aria-label="btn-acf-form-add">
                                    <i className="far fa-plus"></i>
                                    <span>Donate to another programme</span>
                                </button>
                            </div>
                        )
                    }
                </div>
            </div>
        )
    }
}

export default ItemMoney;